export default {

  setUserList(state, data) {
    state.userList = data
  },
  setUserInfo(state, data) {
    state.userInfo = data
  },
  setUserJobs(state, data) {
    state.userJobs = data
  },
  setAssetList(state, data) {
    state.assetList = data
  },

  setGroupList(state, data) {
    state.groupList = data
  },
  setGroupNames(state, data) {
    state.groupNames = data
  },
  setGroupMembers(state, data) {
    state.groupMembers = data
  },

  setNoticeGroup(state, data) {
    state.noticeGroup = data
  },
  setNoticeList(state, data) {
    state.noticeList = data
  },
  setUserNoticeList(state, data) {
    state.userNoticeList = data
  },
  setUserArchiveNoticeList(state, data) {
    state.userArchiveNoticeList = data
  },
  setManagerNoticeList(state, data) {
    state.managerNoticeList = data
  },
  setManagerHistoryNoticeList(state, data) {
    state.managerHistoryNoticeList = data
  },
  setNoticeDetails(state, data) {
    state.noticeDetails = data
  },
  setUserNoticeDetails(state, data) {
    state.userNoticeDetails = data
  },
  setNoticeGroups(state, data) {
    state.noticeGroups = data
  },

  setFileAddress(state, data) {
    state.fileAddress = data
  },


};
